import { render, staticRenderFns } from "./DeliveryArea.vue?vue&type=template&id=1aef6bb5"
import script from "./DeliveryArea.vue?vue&type=script&lang=js"
export * from "./DeliveryArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports